<template>
     <div class="akpk-card">
        <b-card no-body class="p-3">
            <b-row align-v="center">
                <b-col cols="6">
                    <h3 class="mb-0">
                        AKPK
                    </h3>
                </b-col>
                <b-col cols="6">
                    <span v-if="akpk_issue.length > 0" class="float-right font-weight-600 text-danger">{{ akpk_issue.length }} Issue{{ akpk_issue.length > 1 ? 's' : '' }}</span>
                    <span v-else class="float-right text-muted">No Issue</span>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import { Card, Button } from 'element-ui'
import { mapState } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'

export default {
    name: 'akpk-card',
    components: {
        [Card.name]: Card,
        [Button.name]: Button,
    },
    data() {
        return {
            akpk_issue: '',
        }
    },
    computed:{
        ...mapState(useCustomerStore, ['current_commitment'])
    },
    watch: {
        current_commitment: {
            handler(newVal){
                if(newVal){
                    this.akpk_issue = newVal.credit_report_summary.akpk
                }
            }
        }
    }
}
</script>